<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--xs-90 o-dialog--md-90 o-dialog-h o-dialog-h--85"
    :title="dlTitle"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <img
      v-if="imgUrl"
      :src="imgUrl"
      class="u-img-w"
    >
    <div
      v-else-if="!loading && !imgUrl"
      class="o-img__tip"
    >
      <i class="kestrel-icon ki-frown" />图片资源获取失败！
    </div>
    <div
      v-else
      class="o-img__tip"
    >
      正在加载资源...
    </div>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ViewImgDialog',
  props: {
    dlTitle: {
      type: String,
      default: '查看图片'
    },
    action: {
      type: String,
      default: null,
      required: true
    }
  },
  data () {
    return {
      loading: false, // 页面loading状态
      dialogShow: true, // 模态框dialog显示
      imgUrl: null
    };
  },
  methods: {
    /**
     * @description: 初始化信息
     * @return {*}
     */
    init () {
      this.loading = true;
      this.$axios.get(`${this.action}`)
        .then(rsp => {
          this.imgUrl = 'data:img/jpg;base64,' + rsp.data.data;
        })
        .catch(err => {
          console.error('获取信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.init();
  }
};
</script>

<style scoped lang="scss">
.o-img__tip{
  height: 400px;
  font-size: 16px;
  line-height: 400px;
  color: #C0C4CC;
  text-align: center;;

  .kestrel-icon{
    margin-right: 6px;
    font-size: 22px;
    vertical-align: middle;
  }
}
</style>
